"use strict";

export default function format(value) {
	return isNaN(parseInt(value)) ? (value.trim() === "" ? null : value) : parseInt(value)
}


// WEBPACK FOOTER //
// ./~/vwa/quantity/format.js